// <Seo …/> : la forme composant de useSeo, pour les pages qui n'ont pas
// d'autre raison d'appeler un hook. Ne rend rien.
import { useSeo } from '../lib/seo'

export default function Seo (props) {
  useSeo(props)
  return null
}
